import {IHeaderSummaryData} from '../../client-details/project-data-table/types';
import {AurInfographicCellProps} from './types';
import {t} from 'i18next';
import {ReactComponent as CustomSeperator} from '../../../assests/svg/export-icon.svg';

export const SetupInfoGraphicData = (headerSummary: IHeaderSummaryData) => {
  const aurInfographicData: AurInfographicCellProps[] = [
    {
      primaryText: headerSummary.totalBranches.toString(),
      secondaryText: t('clientDetailsPage.infographicPanel.Branches'),
      seperator: 'RightChevron',
    },
    {
      primaryText: headerSummary.totalDepartments.toString(),
      secondaryText: t('clientDetailsPage.infographicPanel.Departments'),
      seperator: 'RightChevron',
    },
    {
      primaryText: headerSummary.totalProjects.toString(),
      secondaryText: t('clientDetailsPage.infographicPanel.Projects'),
      seperator: 'RightChevron',
    },
    {
      primaryText: headerSummary.totalWorkspaces.toString(),
      secondaryText: t('clientDetailsPage.infographicPanel.Workspace'),
      seperator: 'VerticalLine',
    },
    {
      primaryText: headerSummary.totalPermissionGroups.toString(),
      secondaryText: t('clientDetailsPage.infographicPanel.PermissionGroups'),
    },
  ];
  return aurInfographicData;
};

const aurInfographicTestData: AurInfographicCellProps[] = [
  {
    primaryText: '50',
    secondaryText: 'Dummy text 1',
    seperator: 'RightChevron',
  },
  {
    primaryText: '400',
    secondaryText: 'Dummy text 2',
    seperator: <CustomSeperator />,
  },
  {
    primaryText: '250',
    secondaryText: 'Dummy text 3',
    seperator: 'VerticalLine',
  },
  {
    primaryText: '2550',
    secondaryText: 'Dummy text 4',
    seperator: 'LeftChevron',
  },
  {
    primaryText: '25000',
    secondaryText: 'Dummy text 5',
    seperator: 'RightChevron',
  },
];
export default aurInfographicTestData;
